import { render } from "./EditDescriptionModal.vue?vue&type=template&id=82f1770a"
import script from "./EditDescriptionModal.vue?vue&type=script&lang=js"
export * from "./EditDescriptionModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__